import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { LocalStore } from '../../../store/store.decorator';
import { IStoreDataV3 } from '@df/catalog/store/store';

@Component({
    selector: 'page-store-finder-store',
    templateUrl: 'page-store-finder-store.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageStoreFinderStoreComponent extends UiComponent implements OnInit {
    /**
     * Store
     */
    @Input()
    store?: LocalStore<IStoreDataV3>;
}
